import { ReportsFilter } from '@app/modules/reports/store/reports.state';
import {
  ProvisionCustomReport,
  Report,
  UpdateReportModel,
} from '@app/modules/reports/types/report.types';
import { ApiHeaders } from '@core/core.types';

export class GetReportsListAction {
  static type = '[Reports] GetReportsListAction';
  constructor(
    public filters: ReportsFilter,
    public headers: ApiHeaders,
    public pageToLoad: number,
    public reload: boolean
  ) {}
}

export class GetReportAction {
  static type = '[Reports] GetReportAction';
  constructor(
    public reportId: string,
    public prependOnPage?: boolean
  ) {}
}

export class UpdateReportAction {
  static type = '[Reports] UpdateReportAction';
  constructor(public report: UpdateReportModel) {}
}

export class ProvisionCustomReportAction {
  static type = '[Reports] ProvisionCustomReportAction';

  constructor(public report: ProvisionCustomReport) {}
}

export class ProvisionUploadReportsAction {
  static type = '[Reports] ProvisionUploadReportActions';

  constructor(
    public files: File[],
    public signeeId: string
  ) {}
}

export class ApproveReportAction {
  static type = '[Reports] ApproveReportAction';
  constructor(
    public reportId: string,
    public payload: any
  ) {}
}

export class DisapproveReportAction {
  static type = '[Reports] DisapproveReportAction';
  constructor(public reportId: string) {}
}

export class ArchiveReportAction {
  static type = '[Reports] ArchiveReportAction';
  constructor(public reportId: string) {}
}

export class SetReportsAction {
  static type = '[Reports] SetReportsAction';

  constructor(public reports: Report[]) {}
}

export class RemoveReportAction {
  static type = '[Reports] RemoveReportAction';

  constructor(public reportId: string) {}
}

export class RefreshReportsAction {
  static type = '[Reports] RefreshReportsAction';

  constructor(
    public reportIds: string[],
    public productInventoryItemIds: string[] = []
  ) {}
}
